module.exports = __webpack_public_path__ + "img/blend-it.0e055b7c.svg";